/**
 * Diğer › Sekreter (v0.1.28): the last list the Sekreter sent to Telegram and Sercan's own
 * items. The shapes are the API contract's; this module adds the Turkish labels.
 */

import type { SekreterDigest } from '@twin/contracts';

export type { SekreterDigest as SekreterView, SekreterItem, SekreterManualItem } from '@twin/contracts';

export interface SekreterItemInput {
  title: string;
  detail?: string;
  place?: string;
}

export const SEKRETER_REASON_LABELS: Readonly<Record<NonNullable<SekreterDigest['reason']>, string>> = Object.freeze({
  first: 'ilk liste',
  changed: 'liste değişti',
  morning: 'sabah özeti',
});

/** "human:sercan" reads as "sen", a release seed as "sistem". */
export function actorLabel(actor: string): string {
  if (actor.startsWith('human:')) return 'sen';
  if (actor.startsWith('system:')) return 'sistem';
  return actor;
}
